import React from 'react';
import axios2 from 'services/axios2';
import { Component, createRef } from 'react';
import {Link,hashHistory} from 'react-router-dom';
import './styles.css'
import user2 from "assets/img/user2.png"
import NuAlert2 from 'components/NuAlert2';

class CardEstu extends React.Component {
  nuRef = React.createRef(); //divres
  
  constructor(props) {
    super(props);
    

    this.state={
      visible: false,
      form:{
        nomape_tmp:'',
        dir:'',
        tel:'',
        nro_doc:'',
        foto_path1:'',

      },
    }

    
    
  }
  //Se invoca inmediatamente después de que un componente se monte (se inserte en el árbol)
  componentDidMount() {
    //this.setState({show: aux});
    console.log("did mount");
    
  }
  //-------------------------------------
  buscarClick=(e)=>{
   e.preventDefault()
   //---- tenemos que pedir el nro de doc
   let x = prompt("Dame nro de C.I.")
   this.buscar(x)
  }
  //------------------------------
  buscar=(nro_doc)=>{
    let param =  { 
      nro_doc: nro_doc,
    }
    console.log(param);

    axios2.post(process.env.REACT_APP_API_URL  + "card_estu_find", param)
      .then(res => {
        console.log(res.data)
        if(res.data!==''){ 
        //toast.success(res.data.mensaje);
        //this.nuRef.current.show({'type':'info', "text": res.data.men }); 
        //--- tenemos que redireccionar
        this.setState({form: res.data})
        //this.cargar_data(this.state.id_est, this.state.id_peri);
        //this.props.navigate('/DocenteList');
        //-----------retornamos afuera los datos
        this.props.handleOk(res.data)

        }else{
          this.nuRef.current.show({'type':'info', "text": 'registo no encontrado' }); 
        }

      }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);

    });
  }
  //--------------------------------------------------
  handleClick=(e)=>{
    // 👇️ Use event.preventDefault() if you want to
    // prevent navigation
    e.preventDefault();
    /*let obj = {id_mate: this.props.id_mate,
      nombre: this.props.nombre,
      sigla: this.props.sigla,
    }*/
    //----pasa el item, compeltito totalmente
    this.props.onClick();
    //this.props.onChange(e);
  }
  
  //---------------------------------------------------------------------
  render() {
    
    //console.log(this.props.message);
    
    //let display = this.props.show ==true? 'block':'none';

    //const message = this.props.message;
    //const alertClassName = `alert ${ this.alertClass(message.type) } alert-dismissible fade show`;
    //-- imgSrc
    //-- nombre

    return(
     
      <div>   
        {
          //JSON.stringify(this.state.form )
        }
        <figure className="user-card green clearfix" style={{borderTop: '3px solid #3ecfac'}}>
          <figcaption> 
            <h5 className="titulo_card" style={{color: 'grey'}}><i>Estudiante</i>&nbsp;&nbsp;&nbsp;
              <button className="btn btn-sm btn-default " onClick={(e)=> this.buscarClick(e)} >
                  <i className="fa fa-search"></i> Buscar
              </button>
            </h5>
            <div className="right col-xs-5 text-center"> 
                      {this.state.form.foto_path1 !== ''? (
                        <img src={process.env.REACT_APP_AFILES + this.state.form.foto_path1}
                                  className="avatar img-circle2 img-responsive"
                                  alt="Foto" />
                      ):(
                        <img src={user2} className="avatar" alt="Foto" height="80px"/>
                      )
                      }
            </div>
            {/*<!--<p>Viva el internet</p>-->*/}
            <div className="clearfix1">
              <div className="text-left col-xs-7">
                  <h5>{ this.state.form.nomape_tmp }                         </h5>
                  <ul className="list-unstyled">
                      <li><i className="fa fa-home"></i> { this.state.form.dir }    </li>
                      <li><i className="fa fa-phone"></i> { this.state.form.tel } </li>
                      <li><i className="fa "></i><b>C.I.</b> { this.state.form.nro_doc } </li>
                  </ul>
              </div>
            </div>

            <div className="col-xs-12 bottom text-center">
              
            </div>
            
          </figcaption>
          <NuAlert2 ref={ this.nuRef } />
        </figure>
      </div>
    );
  }
}

/*NuAlert.propTypes = {
  onClose: React.PropTypes.func,
  timeout: React.PropTypes.number,
  message: React.PropTypes.object.isRequired
};*/

CardEstu.defaultProps = {
  imgSrc: '',
  nombre:'',
  id:0,
};

export default CardEstu;